import "@melloware/coloris/dist/coloris.css";
import "@eastdesire/jscolor";
import { LocationDocumentation } from '../location_documentation';
import { forEach } from "lodash";
require("./chat_preview")
require("../../treatments/treatments_select")

export class DCChatSettings extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;
    let settings = await fetch(`/admin/domains/${this.domain_id}.json`);
    this.data = await settings.json();
    console.log(this.data)
    this.innerHTML = 
      `
      <div class="row" id="chat-window-main">
        <div class="location-settings-main col-md-12">
          <h3>Chat Settings</h3>
          <p></p>
        </div>
        <div id="dc-chat-settings-container" class="row location-settings-main col-md-12 col-lg-6">
          <div class="errors-container col-sm-12"></div>
          <div class="col-sm-12 no-gutters location-settings-switch-div location-site-attributes">
            <div>
              <label>Web Chat</label>
            </div>
            <label class="switch">
              <input type="checkbox" class="form-control switch" id="dc-web-chat" ${this.data.site.chat_enabled == 1 ? 'checked' : ''}>
              <span data-cy="dc-web-chat-switch"></span>
            </label>
          </div>
          <div class="col-sm-12 no-gutters location-site-attributes">
            <div>
              <label>Default Chat Team</label>
              <br>
              <span></span>
            </div>
            <select name="" id="default_chat_team_id" is="teams-select" class="select-teams form-control"   data-selected="${this.data.site.default_chat_team_id}"></select>
          </div>
          <div class="col-sm-12 no-gutters location-site-attributes">
            <div>
              <label>Chat Treatment</label>
              <br>
              <span></span>
            </div>
            <select name="" id="chat_message_tree_id" is="message-treatments-select" class="form-control" data-selected="${this.data.domain.message_tree_id}" domain_id="${this.domain_id}" type="chat"></select>
          </div>
          <div class="col-sm-12 no-gutters chat-settings-switch-div location-site-attributes">
            <div>
              <label>Chat Window</label>
              <br>
              <span>Create or manage the branding of your chat window.</span>
            </div>
            <button id="customize-chat-btn" class="btn btn-outline-primary">Customize</button>
          </div>
          <div class="col-sm-12 no-gutters chat-settings-switch-div location-site-attributes">
            <div>
              <label>Quick Reply Responses</label>
              <br>
              <span>Create or manage custom quick replies for your location.</span>
            </div>
            <button id="quick-reply-btn" class="btn btn-outline-primary">Setup</button>
          </div>
          <div class="col-sm-12 no-gutters">                                                                        
            <button class="btn btn-primary pull-right detail-row-button" id="save-dc-chat-settings" data-cy="save-dc-chat-settings">Save</button>
            <button class="btn btn-outline-secondary pull-right detail-row-button step-cancel">Cancel</button>
          </div>
        </div>
        <div></div>
        <div class="col-lg-6 col-md-hidden location-settings-main" style="width: 500px">
        ${LocationDocumentation.chatsettings}
        </div>
      </div>
      <dc-chat-window class="hidden"></dc-chat-window>
      `;

    let quickReplySetup = new QuickReplySetup(this.data.domain.message_center_quick_replies)
    quickReplySetup.classList.add('hidden');
    this.appendChild(quickReplySetup)

    this.querySelector('#customize-chat-btn').addEventListener('click', function(e) {
      e.preventDefault();
      this.querySelector('#chat-window-main').classList.add("hidden");
      this.querySelector('dc-chat-window').classList.remove("hidden");
    }.bind(this))
    this.querySelector('#quick-reply-btn').addEventListener('click', function(e) {
      e.preventDefault();
      this.querySelector('#chat-window-main').classList.add("hidden");
      this.querySelector('quick-reply-setup').classList.remove("hidden");
    }.bind(this))

    this.querySelector('.step-cancel').addEventListener('click', function(e) {
      e.preventDefault();
      this.resetData();
    }.bind(this))

    this.querySelector('#save-dc-chat-settings').addEventListener('click', function(e) {
      e.preventDefault();
      if(this.validate()) {
        this.save();
      }
    }.bind(this))
  }

  show() {
    this.querySelector('#chat-window-main').classList.remove('hidden');
  }

  async resetData() {
    if(await window.confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    let is_valid = true;

    this.querySelector(".errors-container").innerHTML = ``;

    if(this.querySelector('#dc-web-chat').checked && this.querySelector('#default_chat_team_id').value == '') {
      this.querySelector(".errors-container").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <strong>Warning!</strong> To enable Chat you must have a Team selected.
                    </div>`
      is_valid = false;
    }

    return is_valid;
  }

  async save() {
    let data = {
      chat_enabled: this.querySelector('#dc-web-chat').checked ? 1 : 0,
      default_chat_team_id: this.querySelector('#default_chat_team_id').value,
      message_tree_id: this.querySelector('#chat_message_tree_id').value
    }
    let res = await fetch(`/admin/domains/${this.domain_id}/chat_settings`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(data)
    })

    if (!res.ok) // or check for response.status
        throw new Error(res.statusText);
    
    let response = await res.json();
    if(response.success) {
      Common.notify('Chat settings updated', 'success');
    } else {
      Common.notify(`Unable to update chat settings. ${response.error ? response.error : ""}`, 'error');
    }
  }

}

customElements.define('dc-chat-settings', DCChatSettings)

class DCChatWindow extends HTMLElement {
  constructor() {
    super();
    this.domain_id = document.querySelector("#object_id").value;;
    this.preview_data = {};
  }
  async connectedCallback() {
    let settings = await fetch(`/admin/domains/${this.domain_id}/message_center_config`);
    let res = await settings.json();
    // Set default values if config data doesn't exist
    res != null ?
      this.data = res :
      this.data = {
        chat_header_bg_color: '#434a54',
        chat_header_color: '#FFFFFF',
        chat_header_html: 'Start Conversation',
        chat_welcome_html: '<p><span style="background-color: rgb(255, 255, 255);"><font color="#3984c6"><b>Welcome to Chat!</b></font></span></p><p>What can I help you with today?</p>',
        chat_send_color: '#0384e0',
        chat_icon: 'chat_icon_convo',
        chat_icon_color: '#FFFFFF',
        chat_icon_size: '60px',
        chat_icon_bg_color: '#0384e0',
        chat_pop_up_color: '#0384e0',
        chat_pop_up_bg_color: '#FFFFFF',
        chat_pop_up_text: 'Hello, how can we help you today?',
        enable_end_chat: true
      };
    this.innerHTML = 
      `
      <style>
        .chat-window-section {
          margin-bottom: 40px;
        }
        .chat-window-color-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }
        .chat-window-color-row h4 {
          margin: 0 20px 0 0;
        }
        .chat-window-color-row input {
          margin-left: 20px;
          width: 171px;
        }
        .chat-window-icons {
          display: flex;
          width: 550px;
          height: 110px;
          border: solid 1px #ccc;
          border-radius: 4px;
        }
        .chat-window-icon {
          width: 110px;
          border-right: solid 1px #ccc;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .chat-window-icon:last-child {
          border: none;
        }
        .clr-field button {
          height: 93%;
        }
        .chat-window-icon svg {
          width: unset;
          height: unset;
        }
        .chat-window-icon svg:hover {
          cursor: pointer;
        }
        .icon-selected {
          border: solid 3px black !important;
        }
      </style>
      <div id="chat-window-main" class="row">
        <div class="col-sm-12">
          <h3><span id="chat-window-back"></span> Chat Window</h3>
          <p></p>
        </div>
        <div class="col-lg-6 col-md-12 no-gutters chat-window-section">
          <div class="col-sm-11 col-sm-offset-1 chat-window-section">
            <h4>Start Message</h4>
            <textarea class="form-control" id="chat-window-start-message"></textarea>
          </div>
          <div class="col-sm-11 col-sm-offset-1 chat-window-section">
            <div class="col-sm-12 no-gutters chat-window-color-row">
              <h4>Header Colors</h4>
              <div class="col-sm-7 no-gutters pull-right chat-window-color-row">
                <input type="text" id="chat-window-greeting-color" class="form-control" value="${this.data.chat_header_color}">
                <input type="text" id="chat-window-header-color" class="form-control" value="${this.data.chat_header_bg_color}">
              </div>
            </div>
            <textarea class="form-control" id="chat-window-greeting-text">${this.data.chat_header_html}</textarea>
          </div>
          <div class="col-sm-11 col-sm-offset-1 chat-window-section">
            <div class="col-sm-12 no-gutters chat-window-color-row">
              <h4>Eye-Catcher Colors</h4>
              <div class="col-sm-7 no-gutters pull-right chat-window-color-row">
                <input type="text" id="chat-window-eyecatcher-color" class="form-control" value="${this.data.chat_pop_up_color}">
                <input type="text" id="chat-window-eyecatcher-bg-color" class="form-control" value="${this.data.chat_pop_up_bg_color}">
              </div>
            </div>
            <textarea class="form-control" id="chat-window-eyecatcher-text">${this.data.chat_pop_up_text}</textarea>
          </div>
          <div class="col-sm-11 col-sm-offset-1 chat-window-section">
            <div class="col-sm-12 no-gutters chat-window-color-row">
              <h4>Chat Icon Colors</h4>
              <div class="col-sm-7 no-gutters pull-right chat-window-color-row">
                <input type="text" id="chat-window-chat-icon-color" class="form-control" value="${this.data.chat_icon_color}">
                <input type="text" id="chat-window-chat-icon-bg-color" class="form-control" value="${this.data.chat_icon_bg_color}">
              </div>
            </div>
            <div class="col-sm-7 no-gutters">
              <input name="chat-icon-color" id="chat-icons-med" type="radio" ${this.data.chat_icon_size == '60px' ? 'checked' : ''}>
              <label>Medium (Default)</label>
              <input name="chat-icon-color" id="chat-icons-lg" type="radio" ${this.data.chat_icon_size == '100px' ? 'checked' : ''}>
              <label>Large</label>
            </div>
            <div class="chat-window-icons">
              <div class="chat-window-icon ${this.data.chat_icon == 'chat_icon_convo' ? 'icon-selected' : ''}" id="chat_icon_convo">${DCChatWindow.icons.chat_icon_convo}</div>
              <div class="chat-window-icon ${this.data.chat_icon == 'chat_icon_oval' ? 'icon-selected' : ''}" id="chat_icon_oval">${DCChatWindow.icons.chat_icon_oval}</div>
              <div class="chat-window-icon ${this.data.chat_icon == 'chat_icon_oval_outline' ? 'icon-selected' : ''}" id="chat_icon_oval_outline">${DCChatWindow.icons.chat_icon_oval_outline}</div>
              <div class="chat-window-icon ${this.data.chat_icon == 'chat_icon_rect_convo' ? 'icon-selected' : ''}" id="chat_icon_rect_convo">${DCChatWindow.icons.chat_icon_rect_convo}</div>
              <div class="chat-window-icon ${this.data.chat_icon == 'chat_icon_rect' ? 'icon-selected' : ''}" id="chat_icon_rect">${DCChatWindow.icons.chat_icon_rect}</div>
            </div>
          </div>
          <div class="col-sm-11 col-sm-offset-1 chat-window-section">
            <div class="col-sm-12 no-gutters chat-window-color-row">
              <h4>Send Icon Color</h4>
              <div class="col-sm-7 no-gutters pull-right chat-window-color-row">
                <input type="text" id="chat-window-send-icon-color" class="form-control" value="${this.data.chat_send_color}">
              </div>
            </div>
          </div>
          <div class="col-sm-11 col-sm-offset-1 chat-window-section" style="margin-bottom: 0px">
            <div class="col-sm-7 no-gutters chat-settings-switch-div chat-window-section">
              <div>
                <h4>Enable End Chat</h4>
              </div>
              <label class="switch">
                <input type="checkbox" class="form-control switch" id="enable-end-chat" ${this.data.enable_end_chat == true ? 'checked' : ''}>
                <span id="enable-end-chat-switch" data-cy="enabled-end-chat-switch"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-12">                                                                        
            <button class="btn btn-primary pull-right campaign-row-button" id="save-dc-chat-window" data-cy="save-dc-chat-window">Save</button>
            <button class="btn btn-outline-secondary pull-right campaign-row-button step-cancel">Cancel</button>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 no-gutters chat-window-section chat-preview-section">
          <div class="col-sm-2 no-gutters chat-preview-col">
            <span class="chat-window-doc">Header Colors <span class="fa-solid fa-chevron-right"></span></span>
            <span class="chat-window-doc">Eye-Catcher Colors <span class="fa-solid fa-chevron-right"></span></span>
            <span class="chat-window-doc">Chat Icon <span class="fa-solid fa-chevron-right"></span></span>
          </div>
          <div class="col-sm-8 no-gutters  chat-preview-col">
            <preview-aichat></preview-aichat>
          </div>
          <div class="col-sm-2 no-gutters chat-preview-col">
            <span class="chat-window-doc"><span class="fa-solid fa-chevron-left"></span> End Chat Button</span>
            <span class="chat-window-doc"><span class="fa-solid fa-chevron-left"></span> Send Icon</span>
          </div>
        </div>
      </div>
      `;

    this.setPreview();
    this.initPickers();
    // Handle preview changes
    this.querySelectorAll(`#chat-window-greeting-color, #chat-window-header-color, 
      #chat-window-eyecatcher-color, #chat-window-eyecatcher-bg-color,
      #chat-window-chat-icon-color, #chat-window-chat-icon-bg-color,
      #chat-window-send-icon-color,
      #chat-icons-med, #chat-icons-lg,
      #enable-end-chat`).forEach(item => { 
      item.addEventListener('change', function() {
        this.setPreview();
      }.bind(this))
    })

    // Handle preview changes (text)
    this.querySelectorAll(`#chat-window-greeting-text, #chat-window-eyecatcher-text`).forEach(item => { 
      item.addEventListener('keyup', function() {
        this.setPreview();
      }.bind(this))
    })
    // Close/back
    this.querySelector('#chat-window-back').addEventListener('click', function(e) {
      e.preventDefault();
      this.removeElement();
    }.bind(this))

    // Clear newly entered data
    this.querySelector('.step-cancel').addEventListener('click', function(e) {
      e.preventDefault();
      this.resetData();
    }.bind(this))

    //Save
    this.querySelector('#save-dc-chat-window').addEventListener('click', function(e) {
      e.preventDefault();
      this.save();
    }.bind(this))

    //Select icon
    this.querySelectorAll('.chat-window-icon svg').forEach(icon => {
      icon.addEventListener('click', function(e) {
        this.selectIcon(e.target);
        this.setPreview();
      }.bind(this))
    })

    $(document).ready(function() {
      $('#chat-window-start-message').summernote({
          tabsize: 2,
          height: 120,
          toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'clear']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['other', ['link', 'codeview']]
          ]
        });
    });
    
    $('#chat-window-start-message').summernote('code', this.data.chat_welcome_html);
  }

  removeElement() {
    this.classList.add("hidden");
    document.querySelector('dc-chat-settings').show();
  }

  setPreview() {
    this.preview_data = {
      "styling": {
        "--theme-header-bg": this.querySelector('#chat-window-header-color').value,
        "--theme-header-fc": this.querySelector('#chat-window-greeting-color').value,
        "--theme-send-color": this.querySelector('#chat-window-send-icon-color').value,
        "--theme-chat-icon-color": this.querySelector('#chat-window-chat-icon-color').value,
        "--theme-chat-icon-bg": this.querySelector('#chat-window-chat-icon-bg-color').value,
        "--theme-pop-bg": this.querySelector('#chat-window-eyecatcher-bg-color').value,
        "--theme-pop-fc": this.querySelector('#chat-window-eyecatcher-color').value,
        "--theme-display-chat-end": this.querySelector('#enable-end-chat').checked ? "block" : "none",
        "--theme-chat-icon-size": this.querySelector('#chat-icons-med').checked ? "60px" : "100px"
    },
    "send-icon-id": "dflt_send_icon",
    "chat-icon-id": this.querySelector('.icon-selected').getAttribute('id'),
    "header-html": this.querySelector('#chat-window-greeting-text').value,
    "welcome-html": this.querySelector('#chat-window-start-message').value,
    "popup-html": this.querySelector('#chat-window-eyecatcher-text').value
    }
    document.querySelector("preview-aichat").applyTheme(this.preview_data);
    this.handleChatIconColor(this.querySelector('#chat-window-chat-icon-color').value, this.querySelector('#chat-window-chat-icon-bg-color').value);
    this.toggleIconSize();
  }

  initPickers() {
    this.headerTextPicker = new JSColor('#chat-window-greeting-color')
    this.headerBGPicker = new JSColor('#chat-window-header-color')
    this.popupPicker = new JSColor('#chat-window-eyecatcher-color')
    this.popupBGPicker = new JSColor('#chat-window-eyecatcher-bg-color')
    this.iconPicker = new JSColor('#chat-window-chat-icon-color')
    this.iconBGPicker = new JSColor('#chat-window-chat-icon-bg-color')
    this.sendIconPicker = new JSColor('#chat-window-send-icon-color')
  }

  handleChatIconColor(color, bg_color) {
    this.querySelector(".icon-selected svg .icon-background-color").setAttribute("fill", bg_color)

    if(this.querySelector(".icon-selected svg .icon-stroke")) {
      this.querySelector(".icon-selected svg .icon-stroke").setAttribute("stroke", color)
    }
    if(this.querySelector(".icon-selected svg .icon-fill")) {
      this.querySelector(".icon-selected svg .icon-fill").setAttribute("fill", color)
    }
  }

  selectIcon(icon) {
    this.querySelector(".icon-selected svg .icon-background-color").setAttribute("fill", '#CCCCCC')
    if(this.querySelector(".icon-selected svg .icon-stroke")) {
      this.querySelector(".icon-selected svg .icon-stroke").setAttribute("stroke", '#FFFFFF')
    }
    if(this.querySelector(".icon-selected svg .icon-fill")) {
      this.querySelector(".icon-selected svg .icon-fill").setAttribute("fill", '#FFFFFF')
    }
    this.querySelector(".icon-selected").style.background = '#FFFFFF';
    this.querySelector('.icon-selected').classList.remove('icon-selected');
    icon.closest('.chat-window-icon').classList.add('icon-selected');

    this.handleChatIconColor(this.querySelector('#chat-window-chat-icon-color').value, this.querySelector('#chat-window-chat-icon-bg-color').value);
  }

  toggleIconSize() {
    if(this.querySelector('#chat-icons-med').checked) {
      this.querySelector('.chat-window-doc:nth-child(3)').style.top = '735px';
      this.querySelector('.chat-window-doc:nth-child(3)').style.right = '-170px';
      this.querySelectorAll('.chat-window-icon svg').forEach(icon => {
        icon.setAttribute("width", 60);
        icon.setAttribute("height", 60);
      })
    } else {
      this.querySelector('.chat-window-doc:nth-child(3)').style.top = '755px';
      this.querySelector('.chat-window-doc:nth-child(3)').style.right = '-150px';
      this.querySelectorAll('.chat-window-icon svg').forEach(icon => {
        icon.setAttribute("width", 100);
        icon.setAttribute("height", 100);
      })
    }
  }

  async resetData() {
    if(await window.confirmPlus(`Are you sure you want to undo your changes?`)) {
      // Color pickers
      this.headerTextPicker.processValueInput(this.data.chat_header_color)
      this.headerBGPicker.processValueInput(this.data.chat_header_bg_color)
      this.popupPicker.processValueInput(this.data.chat_pop_up_color)
      this.popupBGPicker.processValueInput(this.data.chat_pop_up_bg_color)
      this.iconPicker.processValueInput(this.data.chat_icon_color)
      this.iconBGPicker.processValueInput(this.data.chat_icon_bg_color)
      this.sendIconPicker.processValueInput(this.data.chat_send_color)
      // Summernote
      $('#chat-window-start-message').summernote('code', this.data.chat_welcome_html);
      // Other
      this.querySelector('#chat-window-greeting-text').value = this.data.chat_header_html;
      this.querySelector('#chat-window-eyecatcher-text').value = this.data.chat_pop_up_text;
      this.selectIcon(this.querySelector(`#${this.data.chat_icon}`));
      this.data.chat_icon_size == '60px' ? this.querySelector('#chat-icons-med').checked = true : this.querySelector('#chat-icons-lg').checked = true;
      this.toggleIconSize();
      this.data.enable_end_chat == true ? this.querySelector('#enable-end-chat').checked = true : this.querySelector('#enable-end-chat').checked = false;
      this.setPreview();
    }
  }

  validate() {
    return true
  }

  async save() {
    if(this.validate()) {
      let data = {
        chat_header_color: this.querySelector('#chat-window-greeting-color').value,
        chat_header_bg_color: this.querySelector('#chat-window-header-color').value,
        chat_header_html: this.querySelector('#chat-window-greeting-text').value,
        chat_welcome_html: this.querySelector('#chat-window-start-message').value,
        chat_send_color: this.querySelector('#chat-window-send-icon-color').value,
        chat_icon: this.querySelector('.icon-selected').getAttribute('id'),
        chat_icon_size: this.querySelector('#chat-icons-med').checked ? '60px' : '100px',
        chat_icon_color: this.querySelector('#chat-window-chat-icon-color').value,
        chat_icon_bg_color: this.querySelector('#chat-window-chat-icon-bg-color').value,
        chat_pop_up_color: this.querySelector('#chat-window-eyecatcher-color').value,
        chat_pop_up_bg_color: this.querySelector('#chat-window-eyecatcher-bg-color').value,
        chat_pop_up_text: this.querySelector('#chat-window-eyecatcher-text').value,
        enable_end_chat: this.querySelector('#enable-end-chat').checked ? true : false
      }

      let res = await fetch(`/admin/domains/${this.domain_id}/message_center_config`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('Chat window settings updated. It may take up to 15 minutes for the new custom theme to appear.', 'success');
        this.data = data;
      } else {
        Common.notify(`Unable to update chat window settings. ${response.error ? response.error : ""}`, 'error');
      }
    }
  }
}
DCChatWindow.icons = {
  chat_icon_convo: `<svg width="60" height="60" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="icon-background-color" cx="40" cy="40" r="40" fill="#CCCCCC"/>
        <path class="icon-stroke" d="M16 53 s6 0 10 -4 c28 6 32 -18 24 -25 c-18 -19 -46 5 -29 20 c-2 5 -3 5 -5 9" stroke="#FFF" stroke-width="4" stroke-linecap="round" />
        <path class="icon-background-color icon-fill" d="M67 65 s-3 -1 -5 -9 c5 -5 10 -20 -5 -28 c3 20 -15 30 -30 26 c10 10 18 9 27 7 c3 1 5 4 13 5 Z" fill="#FFF" stroke="none"/>
      </svg>`,
  chat_icon_oval: `<svg width="60" height="60" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="icon-background-color" cx="40" cy="40" r="40" fill="#CCCCCC"/>
        <path class="icon-stroke icon-fill" d="M62 61 s-3 -1 -5 -9 c5 -5 10 -20 -5 -31  s-45 5 -30 29 c10 10 18 9 27 7 c3 1 5 4 13 5" fill="#FFF" stroke="#FFF" stroke-width="5" stroke-linecap="round"/>
      </svg>`,
  chat_icon_oval_outline: `<svg width="60" height="60" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="icon-background-color" cx="40" cy="40" r="40" fill="#CCCCCC"/>
        <path class="icon-stroke" d="M62 61 s-3 -1 -5 -9 c5 -5 10 -20 -5 -31  s-45 5 -30 29 c10 10 18 9 27 7 c3 1 5 4 13 5" fill="none" stroke="#FFF" stroke-width="4" stroke-linecap="round"/>
      </svg>`,
  chat_icon_rect_convo: `<svg width="60" height="60" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="icon-background-color" cx="40" cy="40" r="40" fill="#CCCCCC"/>
        <path class="icon-stroke" d="M24 57 l11 -10 h14 s3 0 4 -4 v-19 s0 -3 -4 -4 h-28 s-3 0 -4 4 v19 s0 4 4 4 h4 Z M25 30 h20 M25 36 h15" fill="none" stroke="#FFF" stroke-width="2" stroke-linecap="round"/>
        <path class="icon-background-color icon-fill" d="M57 69 v-8 s5 0 7 -7 v-17 s0 -5 -7 -7 v15 s0 7 -7 7 h-12 l-7 7 h14 l11 10 Z" fill="#FFF"/>
      </svg>`,
  chat_icon_rect: `<svg width="60" height="60" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle class="icon-background-color" cx="40" cy="40" r="40" fill="#CCCCCC"/>
        <path class="icon-fill" d="M56 68 v-11 s8 0 9 -9 v-20 s0 -8 -9 -9 h-31 s-8 0 -9 9 v20 s0 8 9 9 h17 l13 11 Z" fill="#FFF"/>
      </svg>`
}

customElements.define('dc-chat-window', DCChatWindow)

class QuickReplySetup extends HTMLElement {
  constructor(quick_replies) {
    super();
    this.quick_replies = quick_replies;
    this.deleted_replies = [];
  }
  async connectedCallback() {
    this.domain_id = document.querySelector("#object_id").value;
    this.innerHTML =
      `
      <style>
        .quick_reply_header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
        }

        quick-reply {
          counter-increment: item-number;
        }
        
        .quick_reply_ordinal::before {
          content: counter(item-number);
        }

        quick-reply:first-child .quick_reply_arrows > .quick_reply_up,
        quick-reply:last-child .quick_reply_arrows > .quick_reply_down {
          display: none;
        }
      </style>
      <div class="col-lg-7 col-md-12 quick_reply_header">
        <h3><span id="quick-reply-back"></span> Setup Custom Quick Replies</h3>
        <button class="btn btn-outline-primary pull-right" id="add_quick_reply">Add Quick Reply</button>
      </div>
      <div class="col-lg-7 col-md-12 quick_reply_section">
        
      </div>
      <div class="col-lg-7 col-md-12 no-gutters">                                                                        
        <button class="btn btn-primary pull-right detail-row-button" id="save_quick_reply_setup" data-cy="save_quick_reply_setup">Save</button>
        <button class="btn btn-outline-secondary pull-right detail-row-button step-cancel">Cancel</button>
      </div>
      `;

    if(this.quick_replies.length > 0) {
      this.quick_replies.forEach(data => {
        let reply = new QuickReply(this.removeReply.bind(this), data);
        this.querySelector('.quick_reply_section').appendChild(reply);
      })
    } else {
      let reply = new QuickReply(this.removeReply.bind(this));
      this.querySelector('.quick_reply_section').appendChild(reply);
    }

    this.querySelector('#add_quick_reply').addEventListener('click', function(e) {
      e.preventDefault();
      let quick_reply = new QuickReply(this.removeReply.bind(this))
      this.querySelector('.quick_reply_section').appendChild(quick_reply);
      this.toggleAddButton();
    }.bind(this))

    this.querySelectorAll('#quick-reply-back, .step-cancel').forEach(e => {
      e.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.add('hidden');
        document.querySelector('dc-chat-settings').show();
      }.bind(this))   
    })

    this.querySelector('#save_quick_reply_setup').addEventListener('click', function(e) {
      e.preventDefault();
      this.save();
    }.bind(this))

    this.toggleAddButton();
  }

  toggleAddButton() {
    if(this.querySelectorAll('quick-reply').length >= 15) {
      this.querySelector('#add_quick_reply').classList.add('hidden');
    } else if (this.querySelectorAll('quick-reply').length < 15) {
      this.querySelector('#add_quick_reply').classList.remove('hidden');
    }
  }

  getData() {
    let data = {
      domain_id: this.domain_id,
      quick_replies: []
    };

    this.deleted_replies.forEach(obj => {
      data.quick_replies.push(obj)
    })

    this.querySelectorAll('quick-reply').forEach(e => {
      data.quick_replies.push(e.getData())
    })

    let ordinal_counter = 1;
    data.quick_replies.map(e => {
      if(e && !e.deleted) {
        e.ordinal = ordinal_counter
        ordinal_counter ++
      }
    })

    return data
  }

  removeReply(data, elem) {
    this.deleted_replies.push(data);
    elem.remove();
  }

  validate() {
    let is_valid = true;
    this.querySelectorAll('quick-reply').forEach(e => {
      if(!e.validate()) {
        is_valid = false;
      }
    })

    if(!is_valid) {
      Common.notify('Quick reply must have text.', 'error');
    }
    return is_valid
  }

  async save() {
    if(!this.validate()) {
      return
    }

    let data = this.getData();

    let res = await fetch(`/admin/domains/${this.domain_id}/save_quick_replies`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: JSON.stringify(data)
    })

    if (!res.ok) // or check for response.status
        throw new Error(res.statusText);
    
    let response = await res.json();
    if(response.success) {
      Common.notify('Quick reply settings updated', 'success');
      this.quick_replies = response.data;
      this.connectedCallback();
    } else {
      Common.notify(`Unable to update quick reply settings. ${response.error ? response.error : ""}`, 'error');
    }
  }
}

customElements.define('quick-reply-setup', QuickReplySetup)

class QuickReply extends HTMLElement {
  constructor(removeReply, reply_data=null) {
    super();
    this.removeReply = removeReply;
    this.reply_data = reply_data;
    this.deleted = false;
  }
  async connectedCallback() {
    this.innerHTML =
      `
      <style>
        quick-reply textarea {
          margin-bottom: 20px;
        }

        .quick_reply_up, .quick_reply_down {
          cursor: pointer;
        }

        .quick_reply_up:hover, .quick_reply_down:hover {
          color: lightgray;
        }
      </style>

      <div class="col-sm-12">
        <h4 class="pull-left">Quick Reply <span class="quick_reply_ordinal"> <span class="quick_reply_arrows"><span class="fa-solid fa-chevron-up quick_reply_up"></span><span class="fa-solid fa-chevron-down quick_reply_down"></span></span></span></h4>
      </div>
      <div class="col-sm-10">
        <textarea class="form-control" maxlength="1000">${this.reply_data ? this.reply_data.reply : ''}</textarea>
      </div>
      <div class="col-sm-2 no-gutters">
        <button class="btn btn-outline-danger pull-right">Remove</button>
      </div>
      `;

    this.querySelector('button').addEventListener('click', function(e) {
      e.preventDefault();
      this.deleted = true;
      this.removeReply(this.getData(), this)
    }.bind(this))

    this.querySelector('.quick_reply_up').addEventListener('click', function() {
      this.moveUp()
    }.bind(this))

    this.querySelector('.quick_reply_down').addEventListener('click', function() {
      this.moveDown()
    }.bind(this))
  }

  getData() {
    let data = {
      quick_reply: this.querySelector('textarea').value,
      id: this.reply_data ? this.reply_data.id : null,
      deleted: this.deleted
    };

    if(!this.reply_data && this.deleted) {
      return false
    } else {
      return data
    }
  }

  validate() {
    let is_valid = true;
    this.querySelector('textarea').classList.remove('error');
    if(!this.deleted && !this.querySelector('textarea').value.trim()) {
      this.querySelector('textarea').classList.add('error');
      is_valid = false;
    }

    return is_valid
  }

  moveUp() {
    this.previousElementSibling.before(this);
  }

  moveDown() {
    this.nextElementSibling.after(this);
  }

}

customElements.define('quick-reply', QuickReply)

export class QuickReplySelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;
    console.log(this.data)
    let options = this.data.quick_replies.length > 0 ? this.data.quick_replies.map(reply => `<option>${reply.reply}</option>`).join("") :
      `<option>How can I help you today?</option>
      <option>Is there anything else I can help you with?</option>
      <option>Let me check my system to see if you are in our service area. May I have your address please?</option>
      <option>You may be out of our service area, but I will still have one of our Sales Team members promptly reach out to confirm.</option>
      <option>Should you have any further questions, please feel free to contact us at any time. Thank you for chatting with me and have a great day!</option>
      <option>Thank you for reaching out and have a great day!</option>
      <option>I apologize for the inconvenience.</option>`
    this.template.innerHTML =`
    <option value="" disabled selected hidden>+ Quick Replies</option>
    ${options}
    `
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/message_center/quick_replies/${this.dataset.domain_id}/`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('quick-reply-select', QuickReplySelect, {extends: 'select'})